import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowDown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6de5ead905834080c767daf4c3db134a676fb685', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fc0f802d998d75e3a577731f6a4588ce866287e3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6024a41a96fdd7c9a05580c7bdb658c83d44a940', d: "m10.252 15.286-3.145-3.145a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l4.597 4.596a.5.5 0 0 0 .356.146.5.5 0 0 0 .357-.146l4.596-4.596a.5.5 0 0 0 0-.707l-.353-.354a.5.5 0 0 0-.707 0l-3.14 3.14V4.561a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDown$1);
            }
            break;
    } });
}

const CosmosIconArrowDown = CosmosIconArrowDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDown, defineCustomElement };
